<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->
            </div>
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <!-- CONTENT -->

            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
                <div aling="center">
                    <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>
                <P> {{ 'WIZARD.Guia5.TITLE' | translate}}</P>
                <P> {{ 'WIZARD.Guia5.SUBTITLE' | translate}}</P>
                <p> {{ 'WIZARD.Guia5.DES' | translate}} </p>

            </div>
            <div class="content-card mainDiv" style=" margin-top: 2%; margin-left: 5%; margin-right: 15%;">
                <h3>{{ 'WIZARD.Guia5.CONTENT.TITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%; ">

                                <h4 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.LABEL01' | translate}}</h4>
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.LABEL02' | translate}}
                            </td>
                            <td style="width: 50%; ">

                                <h4 style="background-color: #F1F1F0; width: 100%;">-</h4>
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.LABEL03' | translate}}
                            </td>
                        </tr>

                    </tbody>
                </table>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>

                        <tr>
                            <td style="width: 50%; ">

                                <h4 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.LABEL04' | translate}}</h4>
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>15-19 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                            <td style="width: 50%; ">

                                <h4 style="background-color: #F1F1F0; width: 100%;">-</h4>
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>45-49 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>20-24 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                            <td style="width: 50%; ">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>50-54 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>25-29 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>55-59 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>30-34 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>60-64 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>40-44 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>70 {{ 'WIZARD.Guia5.CONTENT.LABELYEAR02' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.ESTADO.TITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%;">
                    <tbody style="width: 100%;">
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ESTADO.TITLE' | translate}}</td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ESTADO.LABEL02' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ESTADO.LABEL03' | translate}}</td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ESTADO.LABEL04' | translate}}</td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ESTADO.LABEL05' | translate}}</td>
                            <td style="width: 50%;">

                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.ESTUDIOS.TITLE' | translate}}</h3>

                <table class="blueTable" style="width: 100%;">
                    <tbody style="width: 100%;">
                        <tr>
                            <td style="width: 60%;">{{ 'WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL01' | translate}}</td>
                            <td style="width: 20%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>
                            </td>
                            <td style="width: 20%;">

                            </td>
                        </tr>

                    </tbody>
                </table>

                <table class="blueTable" style="width: 100%;">
                    <tbody *ngFor="let est of nivelEstudios" style="width: 100%;">
                        <tr>
                            <td style="width: 60%;">{{est.nombre | translate}}</td>
                            <td style="width: 20%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ESTUDIOS.OPC1' | translate}}
                            </td>
                            <td style="width: 20%;">

                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon> {{ 'WIZARD.Guia5.CONTENT.ESTUDIOS.OPC2' | translate}} </td>
                        </tr>
                        <tr>

                        </tr>
                    </tbody>
                </table>

                <h3 class="center" style="background-color: #F1F1F0; width: 100%; padding-left: 44%;"> {{ 'WIZARD.Guia5.CONTENT.LABEL05' | translate}}</h3>
                <h4 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.LABEL06' | translate}}</h4>
                <h4 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.LABEL07' | translate}}</h4>

                <h4 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.PUESTO.TITLE' | translate}}</h4>
                <table class="blueTable" style="width: 100%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PUESTO.LABEL01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PUESTO.LABEL02' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PUESTO.LABEL03' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PUESTO.LABEL04' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.CONTRATACION.TITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.CONTRATACION.LABEL01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.CONTRATACION.LABEL03' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.CONTRATACION.LABEL02' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.CONTRATACION.LABEL04' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.PERSONAL.TITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PERSONAL.LABEL01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PERSONAL.LABEL02' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.PERSONAL.LABEL03' | translate}}
                            </td>
                            <td style="width: 50%;">

                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.JORNADA.TITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.JORNADA.LABEL01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.JORNADA.LABEL03' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.JORNADA.LABEL02' | translate}}
                            </td>
                            <td style="width: 50%;">

                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.ROTACION.TITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ROTACION.OPC1' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.ROTACION.OPC2' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.TITLE' | translate}}</h3>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.SUBTITLE' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL05' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL02' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL06' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL03' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL07' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL04' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL08' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3 style="background-color: #F1F1F0; width: 100%;">{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABELIN' | translate}}</h3>
                <table class="blueTable" style="width: 100%; padding-left: 3%;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL01' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL05' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL02' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL06' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL03' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL07' | translate}}
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL04' | translate}}
                            </td>
                            <td style="width: 50%;">
                                <mat-icon mat-list-icon>check_box_outline_blank</mat-icon>{{ 'WIZARD.Guia5.CONTENT.EXPERIENCIA.LABEL08' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table><br>
            </div>
            <!--<div *ngIf=" dataId.id == datita.position ">-->
        </div>

        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->